<div>
  <button
    *ngIf="!isRecreatedRecoveryCodes"
    mat-icon-button
    class="read-recovery-codes__close"
    (click)="matDialogRef.close()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div class="read-recovery-codes__content">
    <div [@slideIn]="configureRecoveryCodesStep">
      <insert-password
        *ngIf="configureRecoveryCodesStep === 0"
        [isLoading]="isLoading"
        [isClose]="nextStepAfterNewTemporaryToken === 1"
        (back)="
          nextStepAfterNewTemporaryToken === 1
            ? matDialogRef.close()
            : (configureRecoveryCodesStep = nextStepAfterNewTemporaryToken - 1)
        "
        (next)="nextStepAfterNewTemporaryToken === 1 ? getRecoveryCodes($event) : recreateRecoveryCodes($event)"
      ></insert-password>

      <recovery-codes
        *ngIf="configureRecoveryCodesStep === 1"
        [recoveryCodes]="recoveryCodes"
        [isNew]="isRecreatedRecoveryCodes"
        [me]="me"
      >
        <button
          *ngIf="!isRecreatedRecoveryCodes"
          mat-raised-button
          class="read-recovery-codes__content__buttons-button read-recovery-codes__content__buttons-button--secondary"
          (click)="configureRecoveryCodesStep = 2"
        >
          {{ 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.GENERATE.BUTTON' | translate }}
        </button>

        <a
          mat-raised-button
          [href]="downloadRecoveryCodesUrl"
          [download]="'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOCUMENT.NAME' | translate"
          class="read-recovery-codes__content__buttons-button read-recovery-codes__content__buttons-button--secondary"
        >
          {{ 'PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.DOWNLOAD' | translate }}
        </a>

        <button
          *ngIf="isRecreatedRecoveryCodes"
          mat-raised-button
          class="read-recovery-codes__content__buttons-button"
          (click)="matDialogRef.close()"
        >
          {{ 'PROFILE.DIALOGS.EDIT_MFA.CONFIGURE.SUCCESS.FINALIZE' | translate }}
        </button>
      </recovery-codes>

      <generate-step
        *ngIf="configureRecoveryCodesStep === 2"
        (back)="configureRecoveryCodesStep = 1; type = null"
        [isLoading]="isLoading"
        [allUsed]="type === 'all-used'"
        (confirmRegenerate)="recreateRecoveryCodes()"
      ></generate-step>
    </div>
  </div>
</div>
